// extracted by mini-css-extract-plugin
export default {"parentDiv":"profile_parentDiv__Gr4cL","warning":"profile_warning__Qj4+T","info":"profile_info__SvJhu","main":"profile_main__nj3F0"};